import React from 'react';
import './App.css';
import RoutesComponent from "./routesComponent";
import {BrowserRouter} from "react-router-dom";

function App() {
  return (
      <BrowserRouter>
          <div className="App">
              <RoutesComponent />
          </div>
      </BrowserRouter>
  );
}

export default App;
